import { FunctionComponent } from 'react'
import { Loader as HeroLoader, getTheme } from '@conexasaude/conexa-hero'
import useStyles from './styles'

const Loader: FunctionComponent = () => {
  const styles = useStyles()
  const theme = getTheme()

  return (
    <div css={styles.root}>
      <HeroLoader
        ringColor={theme.colors.brand.primary[500]}
        spinColor={theme.colors.brand.primary[300]}
        size="large"
      />
    </div>
  )
}

export default Loader
